export function convertStringWithAndSymbol(input: string): string {
  return input.replace(/ & /g, "And").replace(/\s+/g, "");
}
